import React, { useState, useRef } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, TextField, Box, Checkbox, Select, InputLabel, FormControl, MenuItem, FormControlLabel } from '@mui/material';
import { esES } from '@mui/x-data-grid/locales';

const DynamicDataGrid = ({ showAddInfo, hideFootInfo, rows, columns, onCreate, onUpdate, onDelete }) => {
    const [newRow, setNewRow] = useState({});
    const formRef = useRef(null);

    // Manejar cambios en el formulario de creación
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewRow((prev) => ({ ...prev, [name]: value }));
    };

    const handleChange = (e) => {
        const { name } = e.target;
        setNewRow((prev) => ({ ...prev, [name]: e.target.checked }));
        //setIsChecked(e.target.checked);
    };

    // Crear nuevo registro
    const handleCreate = async () => {
        try {
            await onCreate(newRow);
            setNewRow({}); // Limpiar formulario
        } catch (err) {
            // Error manejado en el componente padre
        }
    };

    // Manejar actualización de celdas
    const handleProcessRowUpdate = async (newRow, oldRow) => {
        try {
            const updatedRow = await onUpdate(newRow);
            return updatedRow;
        } catch (err) {
            return oldRow; // Revertir cambios en caso de error
        }
    };

    // Manejar eliminación
    const handleDeleteClick = (id) => async () => {
        try {
            await onDelete(id);
        } catch (err) {
            // Error manejado en el componente padre
        }
    };

    // Añadir columna de acciones
    const actionColumn = {
        field: 'actions',
        headerName: 'Acciones',
        width: 150,
        renderCell: (params) => (
            <Button
                variant="contained"
                color="error"
                size="small"
                onClick={handleDeleteClick(params.row.id)}
            >
                Eliminar
            </Button>
        ),
    };

    return (
        <Box sx={{ width: '100%' }}>
            {/* Formulario para crear nuevo registro */}
            {
                (showAddInfo &&
                    <form ref={formRef}>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: "wrap" }} >
                            {columns
                                .filter((col) => col.editable)
                                .map((col) => (col.type === 'boolean' ?
                                    <>
                                        <FormControlLabel
                                            sx={{ mb: 2 }}
                                            control={<Checkbox
                                                key={col.field}
                                                name={col.field}
                                                onChange={handleChange}
                                                //value={newRow[col.field] || false} //checked={newRow[col.field] || false}
                                                checked={newRow[col.field] ?? false}
                                                //defaultChecked={false}
                                                label={col.field}
                                            />}
                                            label={col.headerName}
                                        />
                                    </>
                                    : (col.type === 'singleSelect' ?
                                        <>
                                            <FormControl style={{ minWidth: '210px' }}>
                                                <InputLabel>{col.headerName}</InputLabel>
                                                <Select
                                                    sx={{ mb: 2 }}
                                                    width={100}
                                                    name={col.field}
                                                    value={newRow[col.field] || ''}
                                                    onChange={handleInputChange}
                                                    label={col.headerName}
                                                    required={col.required}
                                                >
                                                    {col.valueOptions?.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </>
                                        :
                                        <>
                                            <TextField
                                                sx={{ mb: 2 }}
                                                key={col.field}
                                                name={col.field}
                                                label={col.headerName}
                                                value={newRow[col.field] || ''}
                                                onChange={handleInputChange}
                                                type={col.type === 'number' ? 'number' : (col.type === 'boolean' ? 'boolean' : 'text')}
                                                required={col.required}
                                                inputProps={{
                                                    autoComplete: 'off'
                                                }}
                                            />
                                        </>
                                    )))}
                            <Button sx={{ mb: 2 }} variant="contained" onClick={() => {
                                if (formRef.current.reportValidity()) {
                                    handleCreate(); // Llama a handleCreate solo si el formulario es válido
                                }
                            }}>
                                {/*onClick={handleCreate}*/ /*() => formRef.current.reportValidity() && handleCreate()}>*/  /*disabled={Object.keys(newRow).length}>*/}
                                Agregar
                            </Button>
                        </Box>
                    </form>
                )
            }
            {/* DataGrid */}
            <div style={{ height: 'auto', width: '100%' }}>
                <DataGrid
                    rows={rows}
                    //columns={[...columns, actionColumn]}
                    columns={[...columns]}
                    autoHeight
                    rowsPerPageOptions={[5, 10, 20]}
                    editMode="row"
                    processRowUpdate={handleProcessRowUpdate}
                    experimentalFeatures={{ newEditingApi: true }}
                    hideFooter={hideFootInfo}
                    localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                />
            </div>
        </Box >
    );
};

export default DynamicDataGrid;